import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    CardBody,
    Spinner
} from "reactstrap";
import { faCircleCheck, faCircleXmark, faList, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from 'react-select'
import MaterialTable from "material-table";
import { Map, TileLayer, Marker, Tooltip, GeoJSON } from 'react-leaflet'

// style
import "../../../assets/css/map.css";
import "../../../assets/css/loading.css";

// helpers
import { formateDate } from "../../../helpers/formats.js";
import { icon_ecoponto_azul, icon_planotrabalho_azul, icon_avulso_azul, icon_ecoponto_cinza, icon_planotrabalho_cinza, icon_avulso_cinza } from "../../../helpers/icons";
import { formateDateApi } from "../../../helpers/formats";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

import ModalOrdensColetaSequencia from "./components/ModalOrdensColetaSequencia";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function OrdemColetaForm({ history, handleReturn, item, dataOrdemColeta }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    const [setorSelecionado, setSetorSelecionado] = useState(null);

    // Modalidade
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
    const [modalidadeColeta, setModalidadeColeta] = React.useState(null);
    const [registraDestinacao, setRegistraDestinacao] = useState();
    const loadOptionsModalidadesColeta = async () => {
        try {
            const { data } = await api_GET(`modalidadeColeta/GetByConcessionaria/${session.concessionariaId}`);
            setoptionsModalidadesColeta(data);
        } catch (error) {
            showMessage("Aviso", error?.message, 'error', null);
        }
    };

    const handleModalidadesColeta = event => {
        let value = event;
        setModalidadeColeta(value);
        clearErrors("modalidadeColeta");
    }

    // Veiculo
    const [optionsVeiculo, setOptionsVeiculo] = React.useState([]);
    const [veiculo, setVeiculo] = React.useState(null);
    const loadOptionsVeiculo = () => {
        let ordemColetaId = 0
        if (item != null && item.ordemColetaId != null)
            ordemColetaId = item.ordemColetaId;
        if (modalidadeColeta != null) {
            api_GET(`veiculo/GetAtivoByProgramacaoOS/${session.concessionariaId}/${modalidadeColeta.modalidadeColetaId}/${ordemColetaId}/${formateDateApi(dataOrdemColeta)}`).then(result => {
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    setOptionsVeiculo(result.data);
                }
            });
        }
    }

    const handleVeiculoChange = event => {
        let value = event;
        setVeiculo(value);
        clearErrors("veiculo");

        if (item?.statusExecucao !== "Finalizada") {
            api_GET(`usuario/GetOperadorColetaByVeiculo/${value.veiculoId}`).then(result => {
                if (result.status !== 200) {
                    if (result.data == "") {
                        // showMessage("Aviso", "Não foi localizado nenhum Operador de Coleta para o recurso informado.", 'warning', null);
                    }
                    else {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                }
                else {
                    if (result.data != null && optionsOperadorColeta.filter(f => f.usuarioId == result.data.usuarioId).length > 0)
                        handleOperadorColetaChange(result.data);
                    else
                        setOperadorColeta(null);
                }
            });
        }
    }

    // Operador de Coleta
    const [optionsOperadorColeta, setOptionsOperadorColeta] = React.useState([]);
    const [operadorColeta, setOperadorColeta] = React.useState(null);
    const [ordensByOperador, setOrdensByOperador] = React.useState([]);
    const loadOptionsOperadorColeta = () => {
        let ordemColetaId = 0;
        if (item != null && item.ordemColetaId != null)
            ordemColetaId = item.ordemColetaId;

        api_GET(`usuario/GetOperadorColetaDisponivel/${session.concessionariaId}/${ordemColetaId}/${formateDateApi(dataOrdemColeta)}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsOperadorColeta(result.data);
            }
        });
    }

    const handleOperadorColetaChange = event => {
        let value = event;
        setOperadorColeta(value);
        clearErrors("operador_coleta");
        setOrdensByOperador([]);

        setshowLoading(true);
        api_GET(`ordemcoleta/ByOperadorAndDataProgramacao/${value.usuarioId}/${formateDateApi(dataOrdemColeta)}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if ((item != null && result.data.length > 1) || ((item == null || (item != null && item.ordemColetaId == null)) && result.data.length > 0)) {
                    let lista_ordens = result.data;
                    if (item == null || (item != null && item.ordemColetaId == null)) {
                        lista_ordens.push({
                            ordemColetaId: 0,
                            statusExecucaoOrdemColeta: 'Não Programada',
                            setorColeta: { descricao: item != null ? item.setorColetaIdentificacao : "Ordem Avulsa" },
                            veiculo: { placa: veiculo != null ? veiculo.placa : "" },
                            ordemExecucao: 1
                        });
                    }
                    setOrdensByOperador(lista_ordens);
                }
            }
        });
    }

    const [stateModalOrdensColetaSequencia, set_stateModalOrdensColetaSequencia] = React.useState(false);
    const [sequenciaOrdemAtual, set_sequenciaOrdemAtual] = React.useState(1);
    const ReturnModalOrdensColetaSequencia = (ordensExecucao) => {
        set_stateModalOrdensColetaSequencia(false);
        let sequencia = 1;
        if (ordensExecucao != null) {
            if (item == null || (item != null && item.ordemColetaId == null))
                sequencia = ordensExecucao.filter(o => o.ordemColetaId == 0)[0].ordemExecucao;
            else
                sequencia = ordensExecucao.filter(o => o.ordemColetaId == item.ordemColetaId)[0].ordemExecucao;
        }
        set_sequenciaOrdemAtual(sequencia == null ? 1 : sequencia);
    }

    // Destino
    const [optionsDestino, setOptionsDestino] = React.useState([]);
    const [destino, setDestino] = React.useState(null);
    const loadOptionsDestino = () => {
        api_GET(`destino/GetAtivos`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsDestino(result.data);
            }
        });
    }

    const handleDestinoChange = event => {
        let value = event;
        setDestino(value);
        clearErrors("destino");
    }

    // Regional = Divisão Administrativa
    const [optionsRegional, setOptionsRegional] = React.useState([]);
    const [regional, setRegional] = React.useState([]);
    const loadOptionsRegional = () => {
        if (localStorage.getItem("regionais") != null) {
            setOptionsRegional(JSON.parse(localStorage.getItem("regionais")));
        }
        else {
            api_GET(`regional`).then(result => {
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    setOptionsRegional(result.data);
                }
            });
        }
    }

    const handleRegional = event => {
        let value = event;
        setRegional(value);
    }

    // Bairros
    const [optionsBairros, setOptionsBairros] = React.useState([]);
    const [bairros, setBairros] = React.useState([]);
    const loadOptionsBairros = () => {
        let regionais = [];
        regional.map(item => {
            regionais.push(item.regionalId);
        });
        let json_post = {
            regionais: regionais
        }
        api_POST(`pontocoleta/GetBairrosByRegionais`, json_post).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let bairros = [];
                result.data.map(item => {
                    bairros.push({ value: item, label: item })
                });
                setOptionsBairros(bairros);
            }
        });
    }

    const handleBairros = event => {
        let value = event;
        setBairros(value);
    }

    const [centerMap, setcenterMap] = React.useState([-3.755019499914185, -38.5860013961792]);

    // Lista de Pontos de Coleta
    const [list_table, set_list_table] = React.useState([]);
    // Opções para Add Pontos
    const [showPontosColetaAdd, setshowPontosColetaAdd] = React.useState(false);
    const [pontoColetaAdd, setPontoColetaAdd] = React.useState("");
    const [optionsPontosColeta, setOptionsPontosColeta] = React.useState([]);
    const loadOptionsPontosColeta = () => {
        if (item == null && modalidadeColeta == null)
            return;

        let _bairros = [];
        bairros.map(item => {
            _bairros.push(item.value);
        });

        let json_post = {
            setorColetaId: item == null ? null : item.setorColetaId,
            bairros: _bairros,
            modalidadeColetaId: item != null ? item.modalidadeColetaId : modalidadeColeta.modalidadeColetaId,
            dataProgramacao: formateDateApi(dataOrdemColeta),
            showAll: showPontosColetaAdd
        }

        setshowLoading(true);
        api_POST(`PontoColeta/GetListByProgramacaoOrdemColeta`, json_post).then(result => {
            if (result.status !== 200) {
                setshowLoading(false);
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let newoptions = [];
                for (var i in result.data) {
                    if (list_table.filter(f => f.pontoColetaId == result.data[i].pontoColetaId && f.statusColeta == "Programada").length == 0)
                        newoptions.push(result.data[i]);
                }
                setshowLoading(false);
                setOptionsPontosColeta(newoptions);
            }
        });
    }

    const handleMessageAddPontoColetaMap = (ponto) => {
        setPontoColetaAdd(ponto);
        showQuestion("Deseja adicionar o local à Ordem?", ponto.logradouro + "," + ponto.numeroLogradouro, "question", function (result) {
            if (result)
                handleAddPontoColeta(ponto);
        })
    }

    // Delimitações geográficas
    const [showDelimitacaoGeograficaTodos, setshowDelimitacaoGeograficaTodos] = React.useState(false);
    const [delimitacaoGeograficaTodos, setDelimitacaoGeograficaTodos] = React.useState([]);
    const loadDelimitacoesGeograficas = () => {
        if (modalidadeColeta == null)
            return;
        if (delimitacaoGeograficaTodos.length > 0)
            return;

        setshowLoading(true);
        api_GET(`modalidadeColeta/GetListDelimitacaoGeograficaSetor/${modalidadeColeta.modalidadeColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível consultar as delimitações geográficas", result.message, 'error', null);
            }
            else {
                setDelimitacaoGeograficaTodos(result.data);
            }
        });
    }

    // Ações na lista de pontos
    const handleAddPontoColeta = (ponto) => {
        if (pontoColetaAdd == null && ponto == null) {
            showMessage("Aviso", "Selecione um Local de Execução para adicionar", 'warning', null);
            return;
        }

        if (ponto == null)
            ponto = pontoColetaAdd;

        if (list_table.filter(p => p.pontoColetaId == ponto.pontoColetaId && p.statusColeta == "Programada").length > 0) {
            showMessage("Aviso", "Local já incluído na ordem", 'warning', null);
            return;
        }

        ponto.sequencia = list_table.length + 1;

        let new_list = list_table;
        new_list.push(ponto);

        set_list_table(new_list);

        let newoptions = [];
        for (var i in optionsPontosColeta) {
            if (new_list.filter(f => f.pontoColetaId == optionsPontosColeta[i].pontoColetaId && f.statusColeta == "Programada").length == 0)
                newoptions.push(optionsPontosColeta[i]);
        }

        setPontoColetaAdd(null);
        setOptionsPontosColeta(newoptions);
        setcenterMap([ponto.latitude, ponto.longitude]);
    }

    const Remove = (event, rowData) => {
        let newoptions = [];
        optionsPontosColeta.map(m => {
            newoptions.push(m);
        });
        newoptions.push(rowData);
        setOptionsPontosColeta(newoptions)

        let new_list = [];
        list_table.filter(f => f != rowData).map(m => {
            if (m.sequencia + 1 > rowData.sequencia)
                m.sequencia = m.sequencia - 1;
            new_list.push(m);
        });
        set_list_table(new_list);
    }

    const handleSequenciaChange = (value, rowData) => {
        const novaSequencia = parseInt(value);

        if (isNaN(novaSequencia) || novaSequencia <= 0) {
            showMessage("Atenção", "Informe uma sequência válida (maior que zero).", "warning");
            return;
        }

        // Cria cópia da lista atual
        let novaLista = [...list_table];

        // Ordena antes de tudo
        novaLista.sort((a, b) => a.sequencia - b.sequencia);

        // Remove o item alterado da lista
        const itemMovido = novaLista.find(x => x.pontoColetaId === rowData.pontoColetaId);
        novaLista = novaLista.filter(x => x.pontoColetaId !== rowData.pontoColetaId);

        // Calcula posição destino (corrigindo para o intervalo da lista)
        const posicaoDestino = Math.min(Math.max(novaSequencia - 1, 0), novaLista.length);

        // Insere o item na nova posição
        novaLista.splice(posicaoDestino, 0, itemMovido);


        // Reatribui sequências automaticamente (1, 2, 3, ...)
        novaLista = novaLista.map((item, index) => ({
            ...item,
            sequencia: index + 1
        }));

        set_list_table(novaLista);
    };

    // Mapa
    const [delimitacaoGeograficaSetor, setDelimitacaoGeograficaSetor] = React.useState(null);

    // Transferência de pontos para nova ordem
    const [pontosSelecionados, setPontosSelecionados] = useState([]);
    const [payloadOrdemOrigem, setPayloadOrdemOrigem] = useState(null);

    const handleCriarOrdemDaSelecao = () => {
        if (pontosSelecionados.length === 0) return;

        showQuestion("Atenção", "Tem certeza que deseja abrir uma nova Ordem de Serviço com os locais selecionados?", 'question', function (result) {
            if (result) {
                // Filtra os pontos que NÃO foram selecionados (serão mantidos na original)
                const pontosOriginaisMantidos = list_table.filter(p => !pontosSelecionados.some(s => s.pontoColetaId === p.pontoColetaId));

                // Re-sequencia a lista mantida
                const pontosOriginaisResequenciados = pontosOriginaisMantidos.map((p, index) => ({
                    ...p,
                    sequencia: index + 1
                }));

                // Constrói o payload da ordem antiga
                const pontosColetaOld = pontosOriginaisResequenciados.map(item => ({
                    ordemColetaId: item?.ordemColetaId ?? 0,
                    pontoColetaId: item.pontoColetaId,
                    sequencia: item.sequencia,
                    statusColeta: item.statusColeta ?? "Programada"
                }));

                const regionaisOld = regional.map(item => ({
                    ordemColetaId: item?.ordemColetaId ?? 0,
                    regionalId: item.regionalId
                }));

                const json_old_order = {
                    ordemColetaId: item?.ordemColetaId ?? 0,
                    concessionariaId: session.concessionariaId,
                    setorColetaId: item?.setorColetaId ?? setorSelecionado?.setorColetaId ?? null,
                    statusExecucaoOrdemColeta: item?.ordemColetaId == null ? "Programada" : item.statusExecucaoOrdemColeta,
                    modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
                    veiculoId: veiculo.veiculoId,
                    usuarioOperadorColetaId: operadorColeta.usuarioId,
                    ordemColetaAvulsa: setorSelecionado?.setorColetaId == null && item?.setorColetaId == null,
                    destinoId: (registraDestinacao === "Sim" || registraDestinacao === "Apenas Descarregamento") ? (destino ? destino.destinoId : null) : null,
                    permiteColetaSemCadastro: false,
                    dataProgramacao: formateDateApi(dataOrdemColeta),
                    ordemColetaPontoColeta: pontosColetaOld,
                    ordemColetaRegional: regionaisOld,
                    usuarioCadastroId: session.usuarioId,
                    usuarioAtualizacaoId: session.usuarioId,
                    ordemExecucao: sequenciaOrdemAtual
                };

                setPayloadOrdemOrigem(json_old_order);

                setVeiculo(null);
                setOperadorColeta(null);
                setDestino(null);
                setOrdensByOperador([]);

                const pontosNovos = pontosSelecionados.map((p, index) => ({
                    ...p,
                    ordemColetaId: 0,
                    sequencia: index + 1,
                    executadoAnteriormente: false,
                    tableData: { checked: false }
                }));
                set_list_table(pontosNovos);
                setPontosSelecionados([]);

                setTimeout(() => {
                    showMessage("Informação", "Preencha as informações restantes para criar a nova ordem.", "info", null);
                }, 200)
            }
        });
    };

    // Submit e carregamento dos dados
    const onSubmit = async (data) => {
        if (modalidadeColeta == null) {
            setError("modalidadeColeta", { type: "manual", message: "Campo Obrigatório" });
            return;
        }

        if (veiculo == null) {
            setError("veiculo", { type: "manual", message: "Campo Obrigatório" });
            return;
        }

        const pontosColeta = list_table.map(item => ({
            ordemColetaId: payloadOrdemOrigem ? 0 : (item?.ordemColetaId ?? 0),
            pontoColetaId: item.pontoColetaId,
            sequencia: item.sequencia,
            statusColeta: item.statusColeta ?? "Programada"
        }));

        const regionais = regional.map(item => ({
            ordemColetaId: payloadOrdemOrigem ? 0 : (item?.ordemColetaId ?? 0),
            regionalId: item.regionalId
        }));
        const json_submit = {
            ordemColetaId: item?.ordemColetaId ?? 0,
            concessionariaId: session.concessionariaId,
            setorColetaId: item?.setorColetaId ?? setorSelecionado?.setorColetaId ?? null,
            statusExecucaoOrdemColeta: (payloadOrdemOrigem || item?.ordemColetaId == null) ? "Programada" : item.statusExecucaoOrdemColeta,
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            veiculoId: veiculo.veiculoId,
            usuarioOperadorColetaId: operadorColeta.usuarioId,
            ordemColetaAvulsa: setorSelecionado?.setorColetaId == null && item?.setorColetaId == null,
            destinoId: (registraDestinacao === "Sim" || registraDestinacao === "Apenas Descarregamento") ? (destino ? destino.destinoId : null) : null,
            permiteColetaSemCadastro: false,
            dataProgramacao: formateDateApi(dataOrdemColeta),
            ordemColetaPontoColeta: pontosColeta,
            ordemColetaRegional: regionais,
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId,
            ordemExecucao: sequenciaOrdemAtual
        };


        setshowLoading(true);

        if (!!payloadOrdemOrigem) {
            api_POST('ordemColeta/GerarOrdemVinculada', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });

        } else {
            if (json_submit.ordemColetaId == 0) {
                api_POST('ordemColeta', json_submit).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                            handleReturn(result.data);
                        });
                    }
                });
            }
            else {
                api_PUT('ordemColeta', json_submit).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                            handleReturn(result.data);
                        });
                    }
                });
            }
        }
    };


    const columnsProp = [
        {
            title: 'Ações', field: "internal_action",
            editable: false, render: (rowData) =>
                (rowData.statusColeta == null || rowData.statusColeta == "Programada") && item?.statusExecucao !== "Finalizada" && (
                    <FontAwesomeIcon icon={faTrash} style={{ cursor: "pointer" }} onClick={(e) => Remove(e, rowData)} />
                )
        },
        { title: 'Endereço', field: "logradouro", render: (rowData) => rowData.logradouro + ", " + rowData.numeroLogradouro },
        { title: 'Bairro', field: "bairro" },
        { title: 'Identificação', field: "identificacao" },
        { title: 'Área Operacional', field: "territorio" },
        { title: 'Divisão Administrativa', field: "regional" },
        {
            title: 'Status', field: "statusColeta",
            render: (rowData) => rowData.statusColeta == null ? ("Programada") : (rowData.statusColeta)
        },
        {
            title: 'Sequência', field: "sequencia",
            render: (rowData) => (
                <Input
                    type="number"
                    value={rowData.sequencia}
                    onChange={(e) => {
                        const valor = e.target.value;
                        set_list_table((prev) =>
                            prev.map((item) =>
                                item.pontoColetaId === rowData.pontoColetaId
                                    ? { ...item, sequencia: valor }
                                    : item
                            )
                        );
                    }}
                    onBlur={(e) => handleSequenciaChange(e.target.value, rowData)}
                    style={{ width: 70 }}
                    disabled={item?.statusExecucao === "Finalizada"}
                />
            )
        },
        {
            title: 'Executado Anteriormente',
            field: "executadoAnteriormente",
            render: (rowData) =>
                rowData && (
                    <div style={{ textAlign: "center" }}>
                        {rowData?.executadoAnteriormente ? (
                            <FontAwesomeIcon icon={faCircleCheck} color="green" />
                        ) : (
                            <FontAwesomeIcon icon={faCircleXmark} color="red" />
                        )}
                    </div>
                ),
        },
    ]

    const [optionsSetores, setOptionsSetores] = useState([]);
    async function loadSetores() {
        setshowLoading(true);

        try {
            const { data } = await api_GET(`SetorColeta/GetByConcessionaria/${session.concessionariaId}`);
            const listaSetores = data?.map(({ setorColetaId, descricao }) => ({
                setorColetaId,
                identificacao: descricao
            })) ?? [];
            const listaFinal = [
                { setorColetaId: null, identificacao: "Ordem Avulsa" },
                ...listaSetores
            ];
            setOptionsSetores(listaFinal);
            setRegional(
                data?.setorColetaRegional
                    ?.filter(x => x?.regionalId != null)
                    ?.map(x => x.regionalId)
                ?? []
            );
        } catch (error) {
            showMessage("Aviso", "Erro ao carregar setores.", 'error', null);
        } finally {
            setshowLoading(false);
        }
    }

    const carregarDadosPorSetor = async (setorId) => {
        setshowLoading(true)
        try {
            const { data } = await api_GET(`SetorColeta/${setorId}`);
            if (data && data.modalidadeColetaId != null)
                setModalidadeColeta(optionsModalidadesColeta.filter(f => f.modalidadeColetaId == data.modalidadeColetaId)[0]);

            // popula a regional a partir do setor
            if (data && data.setorColetaRegional) {
                const _regionais = optionsRegional.filter(r =>
                    data.setorColetaRegional.some(sr => sr.regionalId === r.regionalId)
                );
                setRegional(_regionais);
            }

            // pegando as ordem que foram removidas
            const { data: pontosRemovidoSetor } = await api_GET(`PontoColeta/GetListPontoColetasRemovidoPeloSetor/${setorId}/${formateDateApi(dataOrdemColeta)}`);
            set_list_table([...pontosRemovidoSetor]);
            if (pontosRemovidoSetor.length > 0)
                setcenterMap([pontosRemovidoSetor[0].latitude, pontosRemovidoSetor[0].longitude]);
        } catch (error) {
            showMessage("Aviso", error.message, 'error', null);
        } finally {
            setshowLoading(false);
        }
    };

    useEffect(() => {
        if (bairros.length > 0)
            loadOptionsPontosColeta();
    }, [bairros]);

    useEffect(() => {
        loadOptionsPontosColeta();
    }, [showPontosColetaAdd])

    useEffect(() => {
        if (item != null && item.modalidadeColetaId != null) {
            setModalidadeColeta(optionsModalidadesColeta.filter(f => f.modalidadeColetaId == item.modalidadeColetaId)[0]);
        }
    }, [optionsModalidadesColeta]);

    useEffect(() => {
        loadDelimitacoesGeograficas();
    }, [showDelimitacaoGeograficaTodos]);

    useEffect(() => {
        if (item == null || (item != null && item.setorColetaId == null))
            loadOptionsBairros();
    }, [regional]);

    useEffect(() => {
        if (item != null && item.destinoId != null) {
            if (optionsDestino.filter(f => f.destinoId == item.destinoId).length > 0)
                setDestino(optionsDestino.filter(f => f.destinoId == item.destinoId)[0]);
        }

    }, [optionsDestino]);

    useEffect(() => {
        if (item != null && item.veiculoId != null) {
            if (optionsVeiculo.filter(f => f.veiculoId == item.veiculoId).length > 0)
                setVeiculo(optionsVeiculo.filter(f => f.veiculoId == item.veiculoId)[0]);
        }

    }, [optionsVeiculo]);

    useEffect(() => {
        if (item != null && item.regionaisId != null) {
            let _regionais = []
            optionsRegional.map(m => {
                if (item.regionaisId.filter(f => f == m.regionalId).length > 0)
                    _regionais.push(m);
            });
            setRegional(_regionais);
        }
    }, [optionsRegional]);

    useEffect(() => {
        if (item != null && item.usuarioOperadorColetaId != null) {
            if (optionsOperadorColeta.filter(f => f.usuarioId == item.usuarioOperadorColetaId).length > 0)
                handleOperadorColetaChange(optionsOperadorColeta.filter(f => f.usuarioId == item.usuarioOperadorColetaId)[0]);
        }

    }, [optionsOperadorColeta]);

    useEffect(() => {
        if (!modalidadeColeta) return;

        loadOptionsVeiculo();

        if (modalidadeColeta.registraDestinacao === "Sim")
            setRegistraDestinacao("Sim");
        else if (modalidadeColeta.registraDestinacao === "Apenas Descarregamento")
            setRegistraDestinacao("Apenas Descarregamento");
        else
            setRegistraDestinacao("Não");

        if (item && modalidadeColeta.modalidadeColetaId === item.modalidadeColetaId)
            set_list_table(item.ordemColetaPontoColeta);
        else
            set_list_table([]);

        setTimeout(function () { loadOptionsPontosColeta() }, 0.5);

    }, [modalidadeColeta]);

    useEffect(() => {
        setValue("data", formateDate(dataOrdemColeta));
        loadOptionsModalidadesColeta();
        loadOptionsVeiculo();
        loadOptionsOperadorColeta();
        loadOptionsDestino();
        setRegistraDestinacao("Não");

        if (item != null) {
            setValue("setorColeta", item.setorColetaIdentificacao);
            setValue("status", item.statusExecucao);

            loadOptionsRegional();

            set_list_table(item.ordemColetaPontoColeta);
            if (item.ordemColetaPontoColeta.length > 0)
                setcenterMap([item.ordemColetaPontoColeta[0].latitude, item.ordemColetaPontoColeta[0].longitude]);

            if (item.delimitacaoGeograficaSetor != "")
                setDelimitacaoGeograficaSetor(item.delimitacaoGeograficaSetor);
        }
        else {
            loadOptionsRegional();
            loadSetores();
            setValue("setorColeta", "Ordem Avulsa");
            setSetorSelecionado({ setorColetaId: null, identificacao: "Ordem Avulsa" });

            setValue("status", "Não Programada");
        }

    }, [item]);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Row>
                <Container fluid>
                    <Card className="shadow">

                        <CardHeader className="border-0">
                            <strong> Ordem de Serviço</strong>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="6" lg="3">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Data
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                innerRef={register({ required: true })}
                                                defaultValue=""
                                                name="data"
                                                placeholder="Data"
                                                type="text"
                                                disabled="disabled"
                                            />
                                        </FormGroup>
                                    </Col>
                                    {item != null ? <Col md="6" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Setor
                                            </label>
                                            <Input
                                                innerRef={register()}
                                                className="form-control-alternative"
                                                name="setorColeta"
                                                placeholder="Plano de Trabalho"
                                                type="text"
                                                disabled="disabled"
                                            />
                                        </FormGroup>
                                    </Col> : <Col md="6" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label">Setor</label>

                                            <Select
                                                name="setorColeta"
                                                value={setorSelecionado && optionsSetores.filter(x => x.setorColetaId === setorSelecionado.setorColetaId)[0]}
                                                options={optionsSetores}
                                                getOptionLabel={(o) => o.identificacao}
                                                getOptionValue={(o) => o.setorColetaId}
                                                isDisabled={item != null || item?.statusExecucao === "Finalizada"}
                                                placeholder="Selecione"
                                                onChange={(value) => {
                                                    setSetorSelecionado(value);
                                                    setValue("setorColeta", value.identificacao);
                                                    if (!!value.setorColetaId)
                                                        carregarDadosPorSetor(value.setorColetaId);
                                                    else
                                                        setModalidadeColeta(null)
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    }

                                    <Col md="6" lg="3">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Status
                                            </label>
                                            <Input
                                                innerRef={register()}
                                                className="form-control-alternative"
                                                name="status"
                                                placeholder="Status"
                                                type="text"
                                                disabled="disabled"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="12">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Modalidade de Serviço
                                            </label>
                                            <Select
                                                name="modalidadeColeta"
                                                options={optionsModalidadesColeta}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                onChange={(value) => { handleModalidadesColeta(value) }}
                                                value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                                                placeholder="Selecione"
                                                isDisabled={item != null || setorSelecionado?.setorColetaId != null || item?.statusExecucao === "Finalizada"}
                                                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                            />
                                            {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Recurso
                                            </label>
                                            <Select
                                                name="veiculo"
                                                options={optionsVeiculo}
                                                getOptionLabel={({ placa }) => placa}
                                                getOptionValue={({ veiculoId }) => veiculoId}
                                                onChange={(value) => { handleVeiculoChange(value) }}
                                                value={veiculo != null && optionsVeiculo.find(obj => obj.veiculoId === veiculo.veiculoId)}
                                                placeholder="Selecione"
                                                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                            />
                                            {errors.veiculo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="5" lg="3">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Operador de Coleta
                                            </label>
                                            <Select
                                                name="operador_coleta"
                                                options={optionsOperadorColeta}
                                                getOptionLabel={({ nome }) => nome}
                                                getOptionValue={({ usuarioId }) => usuarioId}
                                                onChange={(value) => { handleOperadorColetaChange(value) }}
                                                value={operadorColeta != null && optionsOperadorColeta.find(obj => obj.usuarioId === operadorColeta.usuarioId)}
                                                placeholder="Selecione"
                                                isDisabled={item?.statusExecucao === "Finalizada"}
                                                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                            />
                                            {errors.operador_coleta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    {ordensByOperador.length > 0 &&
                                        <Col md="1" lg="1" className="text-center">
                                            <br />
                                            <Button outline color="warning" type="button" onClick={() => set_stateModalOrdensColetaSequencia(true)}><FontAwesomeIcon icon={faList} /></Button>
                                        </Col>
                                    }
                                    {(registraDestinacao == "Sim" || registraDestinacao == "Apenas Descarregamento") &&
                                        <Col md="6" lg="4">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    * Destino
                                                </label>
                                                <Select
                                                    name="destino"
                                                    options={optionsDestino}
                                                    getOptionLabel={({ identificacao }) => identificacao}
                                                    getOptionValue={({ destinoId }) => destinoId}
                                                    onChange={(e) => { handleDestinoChange(e) }}
                                                    value={destino != null && optionsDestino.find(obj => obj.destinoId === destino.destinoId)}
                                                    placeholder="Selecione"
                                                    isDisabled={item?.statusExecucao === "Finalizada"}
                                                    styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                                />
                                                {errors.destino && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    }
                                    {(!item?.setorColetaId && !setorSelecionado?.setorColetaId) &&
                                        <Col md="12" lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Divisão Administrativa
                                                </label>
                                                <Select
                                                    options={optionsRegional}
                                                    name="regional"
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ regionalId }) => regionalId}
                                                    onChange={(value) => { handleRegional(value || []) }}
                                                    value={optionsRegional?.filter(({ regionalId }) => regional != null && regional?.filter(f => f.regionalId == regionalId).length > 0)}
                                                    placeholder="Selecione"
                                                    isDisabled={item?.statusExecucao === "Finalizada"}
                                                    isMulti="true"
                                                />
                                            </FormGroup>
                                        </Col>
                                    }
                                    {(!item?.setorColetaId && !setorSelecionado?.setorColetaId) &&
                                        <Col md="12" lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="input-address" >
                                                    Bairros
                                                </label>
                                                <Select
                                                    options={optionsBairros}
                                                    name="bairros"
                                                    getOptionLabel={({ label }) => label}
                                                    getOptionValue={({ value }) => value}
                                                    onChange={(value) => { handleBairros(value || []) }}
                                                    value={optionsBairros.filter(({ value }) => bairros != null && bairros.filter(f => f.value == value).length > 0)}
                                                    placeholder="Selecione"
                                                    isDisabled={item?.statusExecucao === "Finalizada"}
                                                    isMulti="true"
                                                />
                                                {errors.bairros && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    }
                                    <Col md="8" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Locais de Execução
                                            </label>
                                            <Select
                                                name="pontoColeta"
                                                options={optionsPontosColeta}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ pontoColetaId }) => pontoColetaId}
                                                onChange={(value) => { setPontoColetaAdd(value) }}
                                                value={pontoColetaAdd != null && optionsPontosColeta.find(obj => obj.pontoColetaId == pontoColetaAdd.pontoColetaId)}
                                                placeholder="Selecione"
                                                isDisabled={item?.statusExecucao === "Finalizada"}
                                                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" lg="2">
                                        <label className="form-control-label"></label>
                                        <FormGroup>
                                            <Button outline color="info" type="button" onClick={() => handleAddPontoColeta()} disabled={item?.statusExecucao === "Finalizada"}>Adicionar</Button>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input
                                                    name="pontos_cadastrados_2"
                                                    type="checkbox"
                                                    onChange={(e) => setshowPontosColetaAdd(e.target.checked)}
                                                    innerRef={register()}
                                                    checked={showPontosColetaAdd}
                                                />
                                                Visualizar Todos os Locais de Execução
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    {pontosSelecionados.length > 0 &&
                                        <Col md="12" className="text-right mb-2">
                                            <Button color="primary" type="button" onClick={handleCriarOrdemDaSelecao} disabled={item?.statusExecucao === "Finalizada"}>
                                                Abrir nova ordem ({pontosSelecionados.length})
                                            </Button>
                                        </Col>
                                    }
                                    <Col md="12" className="mt-1 mb-4">
                                        <MaterialTable
                                            title="Lista de Locais de Execução"
                                            columns={columnsProp}
                                            data={list_table}
                                            options={!!item?.ordemColetaId && !payloadOrdemOrigem && {
                                                ...table_style,
                                                isFreeAction: true,
                                                headerStyle: { zIndex: 0 },
                                                selection: true,
                                                selectionProps: rowData => ({
                                                    disabled: rowData.statusColeta !== 'Programada'
                                                })
                                            }}
                                            onSelectionChange={(rows) => setPontosSelecionados(rows)}
                                            localization={table_translate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md="12">
                                        <h4>Mapa de Locais de Execução</h4>
                                    </Col>
                                    <Col md="12">
                                        <div id="map">
                                            <Map center={centerMap} zoom={16}>
                                                <TileLayer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                />
                                                {(list_table != null) && list_table.map(item => (
                                                    <Marker
                                                        key={item.pontoColetaId}
                                                        position={[item.latitude, item.longitude]}
                                                        draggable={false}
                                                        icon={item.categoria == "Ecoponto" ? icon_ecoponto_azul : (item.categoria == "Plano de Trabalho" ? icon_planotrabalho_azul : icon_avulso_azul)}>
                                                        <Tooltip direction='center' offset={[0, 0]} opacity={1} permanent>
                                                            <span>{item.sequencia}</span>
                                                        </Tooltip>
                                                    </Marker>
                                                ))}
                                                {(delimitacaoGeograficaSetor != null && !showDelimitacaoGeograficaTodos) &&
                                                    <GeoJSON data={JSON.parse(delimitacaoGeograficaSetor)}></GeoJSON>
                                                }
                                                {showDelimitacaoGeograficaTodos && delimitacaoGeograficaTodos != null && delimitacaoGeograficaTodos.map(m => (
                                                    <GeoJSON key={m.delimitacaoGeograficaSetorId} data={JSON.parse(m.geoJson)}></GeoJSON>
                                                ))
                                                }
                                                {optionsPontosColeta != null && optionsPontosColeta.map(item => (
                                                    <Marker
                                                        onClick={() => handleMessageAddPontoColetaMap(item)}
                                                        key={item.pontoColetaId}
                                                        position={[item.latitude, item.longitude]}
                                                        draggable={false}
                                                        icon={item.categoria == "Ecoponto" ? icon_ecoponto_cinza : (item.categoria == "Plano de Trabalho" ? icon_planotrabalho_cinza : icon_avulso_cinza)}>
                                                    </Marker>
                                                ))}
                                            </Map>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" lg="6">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input
                                                    name="pontos_cadastrados"
                                                    type="checkbox"
                                                    onChange={(e) => setshowDelimitacaoGeograficaTodos(e.target.checked)}
                                                    innerRef={register()}
                                                />
                                                Visualizar Delimitação Geográfica dos Setores
                                            </label>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="6" className="text-right">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input
                                                    name="pontos_cadastrados"
                                                    type="checkbox"
                                                    onChange={(e) => setshowPontosColetaAdd(e.target.checked)}
                                                    innerRef={register()}
                                                    checked={showPontosColetaAdd}
                                                />
                                                Visualizar Todos os Locais de Execução
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <label className="form-control-label"></label>
                                        <FormGroup>
                                            <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                            <Button color="success">Salvar</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>

                            </form>
                        </CardBody>
                    </Card>
                </Container>
            </Row>
            <ModalOrdensColetaSequencia stateModalOrdensColetaSequencia={stateModalOrdensColetaSequencia} ordensColeta={ordensByOperador} handleReturn={ReturnModalOrdensColetaSequencia} showLoading={setshowLoading}></ModalOrdensColetaSequencia>
        </>
    );
}
